import React from 'react'
import styled from 'styled-components';
import StyledText from '../../components/StyledComponents/StyledText';
import MemberDirectorySettings from './MemberDirectorySettings';
import TimeZone from './TimeZone';
import DisplayTheme from './DisplayTheme';
import Notifications from './Notifications';
import CookieConsentBanner from './CookieConsentBanner';
import ChangeLoginEmail from './ChangeLoginEmail';
import ChangePassword from './ChangePassword';
import LoginHistory from './LoginHistory';

const AccountSettings = () => {
  return (
    <div style={{ backgroundColor: '#f5f5f5' }}>
        <StyledContainer>
            <StyledText 
                fontSize="20px"
                fontWeight={600}
                textColor={'var(--app-primary-color)'}
                >
                Account Settings
            </StyledText>
            <StyledText
                fontSize='15px'
                fontWeight={400}
                textColor={'var(--app-text-color)'}
            >
                Manage your profile and account related settings here.
            </StyledText>
            <div className='row' style={{ marginTop: '40px' }}>
                <div className='col-md-6 gap-4 d-flex flex-column'>
                    <MemberDirectorySettings />
                    {/* <DisplayTheme /> */}
                    <Notifications />
                </div>
                <div className='col-md-6 gap-4 d-flex flex-column'>
                    {/* <TimeZone /> */}
                    {/* <CookieConsentBanner /> */}
                    <ChangeLoginEmail />
                    <ChangePassword />
                </div>
            </div>
            <div className='row mt-4'>
                <div className='col-12'>
                    <LoginHistory />
                </div>
            </div>
        </StyledContainer>
    </div>
  )
}

export default AccountSettings

export const StyledContainer = styled.div`
    max-width: 1102px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 70px;
`;